export function getMeta(name: string): HTMLMetaElement | null {
  return document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
}

export function setMeta(name: string, content: string | null | undefined): void {
  const current = getMeta(name);
  if (current) document.head.removeChild(current);

  if (!content) return;
  const updated = document.createElement('meta');
  updated.name = name;
  updated.content = content;
  document.head.appendChild(updated);
}
